import type { Schema } from '@dealdesk/api-schema';

export type StaffType = Schema<'StaffType'>;

/** Period (YYYY-MM) and staff type scope every staff commission list. */
export interface StaffScope {
  period: string;
  staffType?: StaffType | undefined;
}

export interface StaffListParams extends StaffScope {
  q?: string | undefined;
  sort?: string | undefined;
  page?: number | undefined;
  size?: number | undefined;
}

/** All staff commission keys live under ['staff-commission'] so every mutation can refresh them at once. */
export const staffCommissionKeys = {
  all: ['staff-commission'] as const,
  overview: (s: StaffScope) => [...staffCommissionKeys.all, 'overview', s] as const,
  trend: (s: StaffScope) => [...staffCommissionKeys.all, 'trend', s] as const,
  /** My commission: the twelve months ending at `period`. */
  history: (period: string) => [...staffCommissionKeys.all, 'history', period] as const,
  statements: (p: StaffListParams) => [...staffCommissionKeys.all, 'statements', p] as const,
  statement: (userId: string, period: string) => [...staffCommissionKeys.all, 'statement', userId, period] as const,
  rules: (q?: string) => [...staffCommissionKeys.all, 'rules', q ?? ''] as const,
  runs: () => [...staffCommissionKeys.all, 'runs'] as const,
  run: (id: string) => [...staffCommissionKeys.all, 'run', id] as const,
  adjustments: (p: StaffListParams) => [...staffCommissionKeys.all, 'adjustments', p] as const,
  clawbacks: (p: StaffListParams) => [...staffCommissionKeys.all, 'clawbacks', p] as const,
  deal: (dealId: string) => [...staffCommissionKeys.all, 'deal', dealId] as const,
  /** Scheme choices for a rule's scope (reference data read from bank configuration). */
  schemes: (bankId: string, product: string) => [...staffCommissionKeys.all, 'schemes', bankId, product] as const,
};
